import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Preload critical hero image
const link = document.createElement('link');
link.rel = 'preload';
link.as = 'image';
link.href = 'https://cdn.magicpatterns.com/uploads/ta77n7wJFozjDE85efGpg6/PortadaLibro.png';
link.fetchPriority = 'high';
document.head.appendChild(link);
render(<App data-id="element-234" />, document.getElementById('root'));